import React from 'react';

const Footer = () => {
    return (
        <footer class="footer footer-center p-10  text-primary-content mt-24">
  <div>
  <div className='font-bold text-2xl cursor-pointer flex items-center text-white '>
                <span className='text-3xl text-indigo-600 mr-1 pt-2'>
                    <ion-icon name="code-slash-outline"></ion-icon>
                   
                </span>
                SHAHID
                </div>

     
    <p>Copyright © 2022 - All right reserved</p>
  </div> 
  <div>
    
  </div>
</footer>
    );
};

export default Footer;